export const filterHeaderMapping = {
  informationTypeCounts: 'Information Type',
  brands: 'Brand',
  homeAreas: 'Home Area',
  keywords: 'Keyword',
  seasons: 'Seasonal',
  regions: 'Region',
};